<template>
	<lcsj-dialog v-model="userAccessshow" title="关联用户" :modal="false" @close="closeDialog('perm')" cancel-text="取消" confirm-text="保存" :confirm-loading="isSubmitting" @confirm="userPermSave"><div style="display: flex; align-items: center; justify-content: space-between">
			<div class="uas_01">
				<!-- <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="mini">
				</el-input> -->
				<el-tree
					ref="tree"
					class="filter-tree"
					:default-expand-all="false"
					:data="RoleRight"
					:props="RoleRightProps"
					node-key="keyId"
					show-checkbox
					:filter-node-method="filterNode"
					style="margin-top: 10px"
					@check="checkUser"
				></el-tree>
			</div>
			<el-button type="primary" :disabled="menuOperationTemp.length === 0" icon="el-icon-arrow-right" @click="addToRight"></el-button>
			<div class="uas_02">
				<div v-for="(item, index) in rightListData" :key="item.keyId" class="uas_03">
					<span style="color: var(--app-primary-text)">{{ item.value }}</span>
					<i class="el-icon-delete" style="color: #ff0000" @click="clickDelete(item, index)"></i>
				</div>
			</div>
		</div>
		
	</lcsj-dialog>
</template>

<script>
import { GetRoleLinkUserList, SaveRoleLinkUser } from "../../../api/userApi.js";
import { GetOrganizationUserTreeList } from "../../../api/organizationalApi.js";
export default {
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			userAccessshow: false,
			loading: false,
			filterText: "",
			RoleRight: [],
			RoleRightProps: {
				children: "dtls",
				label: "name"
			},
			menuOperationTemp: [],
			rightListData: []
		};
	},
	computed: {},
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		}
	},

	methods: {
		// 关联用户
		userAccess(row) {
			this.saveroleId = row.keyId;
			this.RoleRight = [];
			this.getLeftTreeData();
		},

		filterNode(value, data) {
			if (!value) return true;
			return data.name.indexOf(value) !== -1;
		},

		checkUser(obj, val) {
			this.menuOperationTemp = val.checkedNodes;
		},

		// 点击箭头
		addToRight() {
			if (this.menuOperationTemp.length > 0) {
				this.menuOperationTemp.forEach((item) => {
					if (item.isActive) {
						let obj = {
							keyId: item.keyId,
							value: item.name
						};
						this.rightListData.push(obj);
					}
				});
				this.rightListData = this.unique(this.rightListData, "keyId");
			} else {
				this.$message.warning("请先选择需要关联的人员！");
			}
		},

		// 数组去重
		unique(arr, key) {
			return Object.values(
				arr.reduce((accumulator, currentValue) => {
					const keyValue = key ? currentValue[key] : currentValue;
					accumulator[keyValue] = currentValue;
					return accumulator;
				}, {})
			);
		},

		// 已选择的点击删除
		clickDelete(item, index) {
			this.rightListData.splice(index, 1);
		},
		// 递归删除空子节点
		recursion(data) {
			data.forEach((item) => {
				if (item.dtls && item.dtls.length > 0) {
					if (item.users && item.users.length > 0) {
						item.users = item.users.map((v) => {
							v.name = v.chName;
							return v;
						});
						item.dtls = [...item.dtls, ...item.users];
					}
					return this.recursion(item.dtls);
				} else {
					if (item.users && item.users.length > 0) {
						item.users = item.users.map((v) => {
							v.name = v.chName;
							return v;
						});
						item.dtls = [...item.dtls, ...item.users];
					}
					// delete item.dtls
				}
			});
			return data;
		},
		// 获取左边的树数据
		getLeftTreeData() {
			let parmer = {};
			GetOrganizationUserTreeList(parmer)
				.then((res) => {
					if (res.code == 1) {
						this.userAccessshow = true;
						this.RoleRight = this.recursion(res.data);
						this.getRightTreeData();
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("加载失败，请稍后再试！");
				});
		},

		// 获取右边的已选择的数据
		getRightTreeData() {
			let parmer = {
				keyId: this.saveroleId
			};
			GetRoleLinkUserList(parmer)
				.then((res) => {
					if (res.code == 1) {
						this.rightListData = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("加载失败，请稍后再试！");
				});
		},

		// 保存关联用户
		userPermSave() {
			if (this.rightListData.length > 0) {
				let parmer = {
					keyId: this.saveroleId,
					keyIds: []
				};
				this.rightListData.forEach((item) => {
					parmer.keyIds.push(item.keyId);
				});
				SaveRoleLinkUser(parmer)
					.then((res) => {
						if (res.code == 1) {
							this.linkUser = [];
							this.$message({
								type: "success",
								message: "关联用户保存成功"
							});
							this.userAccessshow = false;
							this.$parent.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
							this.linkUser = [];
						}
					})
					.catch((err) => {
						this.$message.error("关联用户保存失败，请稍后再试！");
					});
			} else {
				this.$message.warning("请先选择需要关联的人员！");
			}
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.linkUser = [];
			this.userAccessshow = false;
		}
	},
	created() {},
	mounted() {},
	components: {}
};
</script>
<style scoped>
.uas_01 {
	width: 400px;
	height: 500px;
	border: 1px solid var(--app-border);
	border-radius: 20px;
	padding-top: 20px;
	overflow-y: auto;
}

.uas_02 {
	width: 300px;
	height: 500px;
	border: 1px solid var(--app-border);
	border-radius: 20px;
	overflow-y: auto;
}

.uas_03 {
	width: 260px;
	margin-top: 20px;
	margin-left: 20px;
	display: flex;
	justify-content: space-between;
	cursor: pointer;
}
</style>
